<template>
  <div>
    <!-- :before-close="handleClose" -->
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      size="90%"
      :wrapperClosable="false"
    >
      <div class="div-top"></div>
      <div class="form-center" v-loading.fullscreen.lock="loading">
        <el-steps :active="stepActive" align-center style="margin-bottom: 20px">
          <el-step
            title="选择设备信息"
            :status="stepActive == 0 ? 'finish' : 'process'"
          ></el-step>

          <el-step
            title="制定计划"
            :status="stepActive == 1 ? 'finish' : 'process'"
          ></el-step>
        </el-steps>

        <div class="w100" v-if="stepActive == 0">
          <el-button type="primary" @click="handleAddDev">添加设备</el-button>

          <el-table :data="DevData" ref="DevData" style="width: 100%">
            <el-table-column label="序号" width="50" type="index">
            </el-table-column>

            <el-table-column label="设备编号" align="center" prop="DeviceCode">
            </el-table-column>
            <el-table-column label="设备名称" align="center" prop="device_name">
            </el-table-column>
            <el-table-column
              label="设备型号"
              align="center"
              prop="model_number"
            >
            </el-table-column>
            <el-table-column
              label="设备规格"
              align="center"
              prop="specification"
            >
            </el-table-column>
            <el-table-column
              label="生产厂家名称"
              align="center"
              prop="manufacturer"
            >
            </el-table-column>
            <el-table-column
              label="维修商名称"
              align="center"
              prop="maintenance"
            >
            </el-table-column>
            <el-table-column
              label="安装位置"
              align="center"
              prop="InstallationAreaName"
            >
            </el-table-column>

            <!-- <el-table-column label="购置价格" align="center" prop="purchase_price">
        </el-table-column> -->
            <el-table-column
              label="购置日期"
              align="center"
              prop="purchase_date"
            >
              <template slot-scope="scope">
                {{
                  scope.row.purchase_date
                    ? moment(scope.row.purchase_date).format('YYYY-MM-DD')
                    : ''
                }}
              </template>
            </el-table-column>
            <el-table-column label="状态" align="center" prop="State">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.State == 0">停机</el-tag>
                <el-tag type="success" v-if="scope.row.State == 1">开机</el-tag>
                <el-tag type="warning" v-if="scope.row.State == 2">故障</el-tag>
                <el-tag type="danger" v-if="scope.row.State == 3">报废</el-tag>
              </template>
            </el-table-column>
            <!-- <el-table-column label="金额" align="center" prop="Amount"> </el-table-column> -->

            <el-table-column label="操作" width="80">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="DevData.splice(scope.$index, 1)"
                  style="color: #f78989"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="w100" v-if="stepActive == 1">
          <el-form :model="form" ref="form" label-width="140px" :rules="rules">
            <el-row>
              <el-col :span="8">
                <el-form-item label="巡检计划名称" prop="Name">
                  <el-input
                    v-model="form.Name"
                    placeholder="请输入巡检计划名称"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="计划开始日期" prop="StartTime">
                  <el-date-picker
                    v-model="form.StartTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="计划结束日期" prop="EndTime">
                  <el-date-picker
                    v-model="form.EndTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="间隔时长" prop="PeriodicityValue">
                  <el-input-number
                    v-model="form.PeriodicityValue"
                    placeholder="请输入间隔时长"
                    controls-position="right"
                    style="width: 100%"
                    :step="1"
                    :precision="0"
                    :min="1"
                  ></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="间隔单位" prop="Periodicity">
                  <el-radio-group v-model="form.Periodicity">
                    <el-radio :label="0">天</el-radio>
                    <el-radio :label="1">周</el-radio>
                    <el-radio :label="2">月</el-radio>
                    <el-radio :label="3">年</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="描述" prop="Remarks">
              <quill-editor
                ref="myQuillEditor"
                v-model="form.Remarks"
                :options="editorOption"
                style="height: 600px"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="footer" v-loading="loading">
        <el-button @click="close">取消</el-button>
        <el-button @click="stepActive--" v-if="stepActive > 0" type="primary"
          >上一步</el-button
        >
        <el-button @click="nextStep" v-if="stepActive < 1" type="primary"
          >下一步</el-button
        >
        <el-button type="primary" @click="handleSubmit" v-if="stepActive == 1"
          >保&nbsp;&nbsp;存</el-button
        >
      </div>
      <DevDialog
        ref="DevDialog"
        @select="handleDevSelect"
        IsShowClassify
      ></DevDialog>
      <FittingsOut ref="FittingsOut" @select="selectFittingsOut"></FittingsOut>
      <UserDialog ref="UserDialog" @select="handleUserSelect"></UserDialog>
    </el-drawer>
  </div>
</template>
<script>
import DevDialog from '@/components/DevDialog/DevDialog.vue'
import FittingsOut from '@/components/Fittings/FittingsOut.vue'
import UserDialog from '@/components/UserDialog/UserDialog.vue'

import Token from '@/utils/cache/TokenCache.js'
import moment from 'moment'
export default {
  data() {
    return {
      editorOption: {
        theme: 'snow', // 主题
        placeholder: '',
        AIshow: false,
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              [{ header: 1 }, { header: 2 }],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ script: 'sub' }, { script: 'super' }],
              [{ indent: '-1' }, { indent: '+1' }],
              [{ direction: 'rtl' }],
              [{ size: ['small', false, 'large', 'huge'] }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }, { background: [] }],
              [{ font: [] }],
              [{ align: [] }],
              ['clean', 'link'],
              // ["addBtn"],
            ], // 自定义工具栏选项
            // handlers: {
            //   addBtn: () => {
            //     this.AIOpen();
            //   },
            // },
          },
        },
      },
      moment,
      DictionaryMainList: [],
      stepActive: 0,
      active: [1, 2, 3, 4],
      title: '',
      loading: false,
      token: 'Bearer ' + Token.getToken(),

      form: {
        Name: '',
        StartTime: '',
        EndTime: '',
        Remarks: '',
        DeviceType: '',
      },
      DevData: [],
      MaterialsData: [],
      UserData: [],
      rules: {
        Code: [
          { required: true, message: '请输入巡检计划编号', trigger: 'blur' },
        ],
        Name: [
          { required: true, message: '请输入巡检计划名账号', trigger: 'blur' },
        ],
        Type: [{ required: true, message: '请选择类型', trigger: 'change' }],
        Periodicity: [
          { required: true, message: '请选择周期性', trigger: 'change' },
        ],
        PeriodicityValue: [
          { required: true, message: '请输入周期间隔', trigger: 'blur' },
        ],
        StartTime: [
          { required: true, message: '请选择开始日期', trigger: 'change' },
        ],
        EndTime: [
          { required: true, message: '请选择结束日期', trigger: 'change' },
        ],
        OperatorIds: [
          { required: true, message: '请选择人员信息', trigger: 'change' },
        ],
      },
      drawer: false,
      isCopy: false,
    }
  },
  props: {},
  components: { DevDialog, FittingsOut, UserDialog },
  methods: {
    DeviceTypeChange() {
      this.DevData = []
    },
    getDictionaryMainList() {
      this.$http
        .post('/PB/PB_Project/GetDictionaryMainList', {})
        .then((res) => {
          if (res.Success) {
            this.DictionaryMainList = res.Data
          }
        })
    },
    nextStep() {
      if (this.stepActive == 0) {
        if (this.DevData.length <= 0) {
          this.$notify.warning('请添加设备后进行下一步')
          return
        }
      }
      this.stepActive++
    },
    handleUserSelect(arr) {
      if (this.UserData.length == 0) {
        this.UserData = [...arr]
      } else {
        const duplicateIds = []
        arr.forEach((item) => {
          const exists = this.UserData.some((detail) => detail.Id === item.Id)
          if (exists) {
            duplicateIds.push(`姓名:${item.RealName},手机号:${item.Telephone}`)
          } else {
            this.UserData.push({
              ...item,
            })
          }
        })
        if (duplicateIds.length > 0) {
          this.$notify.warning(
            `以下用户已存在，未重复添加: ${duplicateIds.join(', ')}`
          )
        }
      }
    },
    handleAddUserData() {
      this.$refs.UserDialog.openDialog()
    },
    NumChange(num, row) {
      console.log(num, row)
      if (!Number.isInteger(Number(num))) {
        this.$notify.error('数量不能为小数或负数')
        this.$set(row, 'Num', Math.floor(Number(num)))
      } else if (Number(num) < 0) {
        this.$notify.error('数量不能为小数或负数')
        this.$set(row, 'Num', 0)
      } else if (Number(num) > Number(row.Nums_N)) {
        this.$notify.error('数量不能超过库存数量')
        this.$set(row, 'Num', row.Nums_N)
      }

      // const formattedTotalAmt = ((row.Num || 0) * (row.Price || 0)).toFixed(4);
      // const formattedTotalAmtWithCommas = Number(formattedTotalAmt).toLocaleString(
      //   "en-US",
      //   {
      //     minimumFractionDigits: 4,
      //     maximumFractionDigits: 4,
      //   }
      // );
      // this.$set(row, "TotalAmt", formattedTotalAmtWithCommas);
    },
    selectFittingsOut(arr) {
      console.log(arr)
      if (this.MaterialsData.length == 0) {
        arr.forEach((item) => {
          this.MaterialsData.push({
            ...item,
            Num: '',
          })
        })
      } else {
        const duplicateIds = []
        arr.forEach((item) => {
          const exists = this.MaterialsData.some(
            (detail) => detail.MaterialId === item.MaterialId
          )
          if (exists) {
            duplicateIds.push(`备件名称:${item.Name},备件编号:${item.Code}`)
          } else {
            this.MaterialsData.push({
              ...item,
              Num: '',
            })
          }
        })
        if (duplicateIds.length > 0) {
          this.$notify.warning(
            `以下设备已存在，未重复添加: ${duplicateIds.join(', ')}`
          )
        }
      }
    },
    handleAddMaterialsData() {
      this.$refs.FittingsOut.openDialog()
    },
    handleDevSelect(arr) {
      console.log(arr)
      arr.forEach((item) => {
        this.$set(item, 'DevicetItemId', item.Id)
      })
      if (this.DevData.length == 0) {
        this.DevData = [...arr]
      } else {
        const duplicateIds = []
        arr.forEach((item) => {
          const exists = this.DevData.some(
            (detail) => detail.DevicetItemId === item.DevicetItemId
          )
          if (exists) {
            duplicateIds.push(
              `设备名称:${item.device_name},设备编号:${item.DeviceCode}`
            )
          } else {
            this.DevData.push({
              ...item,
            })
          }
        })
        if (duplicateIds.length > 0) {
          this.$notify.warning(
            `以下设备已存在，未重复添加: ${duplicateIds.join(', ')}`
          )
        }
      }
    },
    handleAddDev() {
      this.$refs.DevDialog.openDialog(true)
    },

    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 20

      if (!isJPG) {
        this.$notify.error('上传图片只能是 JPG 或 PNG 格式!')
      }
      if (!isLt2M) {
        this.$notify.error('上传头像图片大小不能超过 20MB!')
      }
      return isJPG && isLt2M
    },
    handleAvatarSuccess(res) {
      console.log(res, 'res')
      if (res.status == 'done') {
        this.form.HeadImg = res.url

        console.log(this.form.HeadImg)
      } else {
        this.$notify.error(res.Msg)
      }
    },
    getRoleList() {
      this.$http
        .post('/Base_Manage/Base_Role/GetDataList', {
          SortField: 'CreateTime',
          SortType: 'Desc',
        })
        .then((resJson) => {
          if (resJson.Success) {
            this.RoleList = resJson.Data
          }
        })
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return this.$notify.error('请检查输入项')
        }
        if (this.DevData.length == 0) {
          return this.$notify.error('请选择设备')
        }
        // if (this.MaterialsData.length == 0) {
        //   return this.$notify.error("请选择备件");
        // } else {
        //   let isNum = this.MaterialsData.every((item) => {
        //     return Number(item.Num) > 0;
        //   });

        //   console.log(isNum, "every");
        //   if (!isNum) {
        //     this.$notify.error("请输入备件数量");
        //     return;
        //   }
        // }
        this.loading = true
        this.$http
          .post('/Base_DeviceTreeManage/Device_TaskPlan/TaskPlanSaveData', {
            device_TaskPlan: {
              ...this.form,
              Type: '0',
            },
            Device_TaskPlanDetails: [...this.DevData],
            // device_TaskPlanMaterials: [...this.MaterialsData],
          })
          .then((resJson) => {
            this.loading = false

            if (resJson.Success) {
              this.$notify.success('操作成功!')
              this.$emit('success')
              this.close()
            } else {
              this.$notify.error(resJson.Msg)
            }
          })
      })
    },
    openForm(title, row = {}, isCopy = false) {
      this.drawer = true
      this.isCopy = isCopy
      this.form = {
        Name: '',
        StartTime: '',
        EndTime: '',
        Remarks: '',
        DeviceType: '',
      }
      this.DevData = []
      this.MaterialsData = []
      this.UserData = []
      this.stepActive = 0
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
      this.title = title
      if (row.Id && isCopy) {
        this.getInfo(row.Id)
      }
      this.DictionaryMainList = []
      this.getDictionaryMainList()
    },
    getInfo(id) {
      this.loading = true
      this.$http
        .post(
          '/Base_DeviceTreeManage/Device_TaskPlan/GetTaskPlanDetailData?Id=' +
            id,
          {}
        )
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.DevData = resJson.Data.Device_TaskPlanDetails || []

            this.stepActive = 1
            this.$notify.success('已复制数据，请修改后保存')
            // this.$set(
            //   resJson.Data.device_TaskPlan,
            //   "OperatorIds",
            //   resJson.Data.device_TaskPlan?.OperatorIds.split(",")
            // );
            // this.form = resJson.Data.device_TaskPlan;
            // this.DevData = resJson.Data.device_TaskPlanDetails;
            // this.MaterialsData = resJson.Data.device_TaskPlanMaterials;
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    close() {
      this.drawer = false
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__header {
  margin: 0;
  padding: 10px 20px;
}
.form-center {
  height: calc(100vh - 110px);
  overflow-y: auto;
  padding: 20px;
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
::v-deep .avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 65px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
::v-deep .el-collapse-item__header {
  font-weight: bold;
  font-size: 18px;
}
</style>
